import React from 'react';
import Icon from "components/elements/Icon";
import { IFeature } from "components/pricing/Features/Features";
import { IPricingPlan } from "components/pricing/Plan";
import Text from "components/typography/Text";

type Props = {
    features: IFeature[],
    plans: IPricingPlan[],
    planHasFeature: (plan: string, feature: IFeature) => boolean;
};

export default function MobileFeatures(props: Props) {
    const { features, plans, planHasFeature } = props;

    return (
        <div>
            {features.map((feature) => (
                <div className={"mt-4 last:mb-2 lg:hidden"} key={feature.id}>
                    <Text size={'sm'} color={'text-gray-500'} weight={'normal'} className={'pl-3'}> {feature.name} </Text>
                    <div className={"flex space-x-1 mt-1 rounded-xl overflow-hidden"}>
                        {plans.map((plan) => {
                            const planValue = feature.planValue.find((pv) => pv.plan.name == plan.name);
                            return (
                                <div
                                    className={"flex-1 px-6 py-3 flex justify-center bg-primary-50 text-sm "}
                                    key={plan.id}
                                >
                                    {planValue ? (
                                        <>
                                            {planValue?.value}
                                        </>
                                    ) : (
                                        <>
                                            {planHasFeature(plan.name, feature) ? (
                                                <Icon
                                                    url={"/static/icons/checkmark.svg"}
                                                    className={`bg-primary-900 h-4 w-4`}
                                                />
                                            ) : (
                                                <Icon
                                                    url={"/static/icons/close.svg"}
                                                    className={`bg-purple-dark h-3 w-3 opacity-20`}
                                                />
                                            )}
                                        </>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            ))}
        </div>
    );
}